import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button, Divider, Message } from 'semantic-ui-react';
import TargetBlankLink from '../../components/common/TargetBlankLink';
import { ACCOUNT_PATH } from '../../constants/paths/internal';
import BillingStyle from '../../pages/Billing/style';

const ExtBillingHeader = () => {
  return (
    <>
      <div className="ext-billing-header">
        <h2>Billing</h2>
        <Link to={ACCOUNT_PATH}>
          <Button content="To Settings" circular basic size="tiny" icon="settings" />
        </Link>
      </div>
      <Divider />
    </>
  );
};

interface Props {
  children: React.ReactNode;
}

const ExternalAuthBillingPage = ({ children }: Props) => {
  return (
    <ExtBillingStyles>
      <BillingStyle className="billing">
        <div className="billing__content">
          <ExtBillingHeader />
          {children}
        </div>
      </BillingStyle>
    </ExtBillingStyles>
  );
};

export const BillingCODEDE = () => {
  return (
    <ExternalAuthBillingPage>
      <Message
        icon="info"
        className="ext-billing-message"
        info
        size="large"
        content={
          <>
            Please contact{' '}
            <TargetBlankLink href="https://code-de.org/en/helpdesk">
              <u>CODE-DE Support</u>
            </TargetBlankLink>{' '}
            to get information on how to get larger quotas for Sentinel Hub.
          </>
        }
      />
    </ExternalAuthBillingPage>
  );
};

export const BillingCreo = () => {
  return (
    <ExternalAuthBillingPage>
      <Message
        icon="info"
        className="ext-billing-message"
        info
        size="large"
        content={
          <>
            Check{' '}
            <TargetBlankLink href="https://creodias.eu/-/sinegrise-ltd">
              <u>this page</u>
            </TargetBlankLink>{' '}
            to get information on how to get larger quotas for Sentinel Hub.
          </>
        }
      />
    </ExternalAuthBillingPage>
  );
};

const ExtBillingStyles = styled.div`
  h2 {
    margin-bottom: 0;
  }
  .ext-billing-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .ext-billing-message {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
`;
